<template>
</template>

<script>
export default {
    name: 'route-login',
    created: function () {
        this.$router.replace({ path: 'home' });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/account/RouteLogin.vue